module.exports = __webpack_public_path__ + "static/img/2b.8a3a75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2b.jpg
// module id = yH9+
// module chunks = 0